import React, { useState } from 'react';
import SGMSClient from '../../../js/SGMSClient';
import { store } from '../../../stores/store';
import './CreateAccountForm.css';



const CreateAccountForm = ({onFormSuccess}) => {
  const [login, setLogin] = useState("");
  const [pseudo, setPseudo] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [createError, setCreateError] = useState(false);

  const onPwdChange = e => setPassword(e.target.value)
  const onPwdConfirmChange = e => setPasswordConfirm(e.target.value)

  const matchError = (password !== passwordConfirm)


  const handleCreateAccountSubmit = (e) => {
    e.preventDefault()

    if(!matchError) {
      let { Universe, App } = window.CONFIG.vertexConfig

      SGMSClient.userCreate(Universe, login, password, pseudo)
      .then(() => SGMSClient.login(Universe, App, login, password))
      .then(() => onFormSuccess())
      .catch(() => setCreateError(true))
    }
  }
  return (
    <div className="CreateAccountForm">
       <form onSubmit={handleCreateAccountSubmit}>
          <p>
            <label htmlFor="login_email">{store.t("form_email")}</label>
            <input
            type="email"
            id="login_email"
            required
            value={login}
            onChange={e => {setLogin(e.target.value)}}  />
          </p>
          <p>
            <label htmlFor="login_pseudo">{store.t("form_pseudo")}</label>
            <input
            type="text"
            id="login_pseudo"
            required
            value={pseudo}
            onChange={e => {setPseudo(e.target.value)}}  />
          </p>
          <p>
            <label htmlFor="login_password">{store.t("form_password")}</label>
            <input
            type="password"
            id="login_password"
            value={password}
            required
            onChange={onPwdChange} />
          </p>
          <p>
            <label htmlFor="login_password_confirm">{store.t("form_confirm_password")}</label>
            <input
            type="password"
            id="login_password_confirm"
            required
            value={passwordConfirm}
            onChange={onPwdConfirmChange} />
          </p>
          {matchError && <p className="error">{store.t("form_password_no_match")}</p>}
          {createError && <p className="error">{store.t("user_create_error")}</p>}

          <button disabled={matchError}>{store.t("button_create_user")}</button>
        </form>
    </div>
  );
};

export default CreateAccountForm;
